(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-countdown-timer"] && !Shopify.designMode) return;
  try {
    
  function initializeCountdown() {
    const countdownSection = document.getElementById('countdownSection');
    if (!countdownSection) return;

    function updateCountdown() {
      // Get current time
      const now = new Date();
      
      // Calculate seconds since midnight (00:00:00)
      const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const elapsedSeconds = Math.floor((now - startOfDay) / 1000);
      
      // 24 hours = 86400 seconds
      const secondsInDay = 86400;
      const remainingSeconds = secondsInDay - elapsedSeconds;
      
      // If we've completed a 24-hour cycle, reset
      const secsToUse = remainingSeconds <= 0 ? secondsInDay : remainingSeconds;
      
      // Calculate hours, minutes, seconds (no days)
      const hours = Math.floor(secsToUse / 3600);
      const minutes = Math.floor((secsToUse % 3600) / 60);
      const seconds = secsToUse % 60;
      
      // Update DOM with zero padding
      const updateElement = (id, value) => {
        const element = document.getElementById(id);
        if (element) {
          const paddedValue = String(value).padStart(2, '0');
          element.textContent = paddedValue;
        }
      };
      
      updateElement('hours', hours);
      updateElement('minutes', minutes);
      updateElement('seconds', seconds);
    }
    
    // Initial update
    updateCountdown();
    
    // Update every second
    setInterval(updateCountdown, 1000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCountdown);
  } else {
    initializeCountdown();
  }

  // Reinitialize on Shopify theme editor updates
  if (window.Shopify && window.Shopify.onThemeEditor) {
    document.addEventListener('shopify:section:load', initializeCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
